<template>
  <!-- CPAP 預託院内在庫申込み -->
  <div id="CpapEscrowRequest">
    <section>
      <div id="container-center">
        <form>
          <h1 style="" class="title has-text-centered printTarget">
            預託院内在庫（器械/用品）注文
          </h1>
          <div>
            <b-steps
              v-model="activeStep"
              :animated="true"
              :rounded="true"
              :has-navigation="false"
              label-position="bottom"
            >
              <b-step-item
                step="1"
                label="注文内容入力"
                icon="clipboard-edit-outline"
              >
                <div id="item-contens" v-bind:key="renderKey">
                  <div class="request-title">
                    <b-button
                      class="is-primary"
                      style="float: left"
                      icon-left="home"
                      @click.prevent="back"
                      >ホーム画面
                    </b-button>
                    <b-button
                      class="is-primary"
                      style="float: right"
                      icon-right="chevron-double-right"
                      @click.prevent="Forward"
                      >次へ</b-button
                    >
                    <span>納品先を入力してください。</span>
                  </div>
                  <div class="card-content margin-top">
                    <table>
                      <tr v-if="!customer">
                        <th>対象医療機関<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.targetHospitalName"
                            maxlength="256"
                            class="1"
                            :name="'対象医療機関'"
                            validate="required"
                          />
                        </td>
                      </tr>
                      <tr v-if="!customer">
                        <th>納品先<span class="require" /></th>
                        <td>
                          <div>
                            <b-radio
                              class="td_radio"
                              name="target"
                              v-model="reqParams.delivaryTarget"
                              native-value="branch"
                              disabled
                              >支店</b-radio
                            >
                            <b-radio
                              class="td_radio"
                              name="target"
                              v-model="reqParams.delivaryTarget"
                              native-value="hospital"
                              checked
                              >医療機関</b-radio
                            >
                          </div>
                        </td>
                      </tr>
                      <template
                        v-if="
                          customer || reqParams.delivaryTarget == 'hospital'
                        "
                      >
                        <tr>
                          <th>注文者部署名</th>
                          <td>
                            <input
                              type="text"
                              v-model="reqParams.divisionName"
                              maxlength="100"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>注文者名<span class="require" /></th>
                          <td>
                            <input
                              type="text"
                              v-model="reqParams.ordererName"
                              maxlength="50"
                              class="1"
                              :name="'注文者名'"
                              validate="required"
                            />
                          </td>
                        </tr>
                      </template>
                      <tr
                        v-if="
                          !customer && reqParams.delivaryTarget == 'branch'
                        "
                      >
                        <th>機器納品先支店<span class="require" /></th>
                        <td>
                          <select
                            v-model="reqParams.deliveryTargetBranchOffice"
                            id="branchOfficeCode"
                            validate="required"
                          >
                            <option
                              v-for="brunch in brunchList"
                              :key="brunch.branchOfficeCode"
                              :value="brunch.branchOfficeCode"
                            >
                              {{ brunch.branchOfficeName }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>郵便番号<span class="require" /></th>
                        <td>
                          <input
                            v-model="reqParams.deliveryPostCode"
                            type="text"
                            maxlength="7"
                            style="width: 270px"
                            class="1"
                            :class="{ 'border-red': invalidPostcode }"
                            name="郵便番号"
                            validate="required|numeric"
                            :placeholder="postcodePlaceholder"
                          />
                          <b-button
                            style="
                              margin-left: 10px;
                              width: 150px;
                              height: 27px;
                            "
                            v-on:click="
                              addressSearch(reqParams.deliveryPostCode)
                            "
                          >
                            郵便番号検索
                          </b-button>
                          <div v-show="invalidPostcode" class="text-red">
                            {{ invalidNumberMessage }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>住所<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.deliveryAddress1"
                            maxlength="256"
                            class="1"
                            :name="'住所'"
                            validate="required"
                          />
                        </td>
                      </tr>
                      <tr
                        v-if="
                          customer || reqParams.delivaryTarget == 'hospital'
                        "
                      >
                        <th>住所（丁目、番地）<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.deliveryAddress2"
                            maxlength="256"
                            class="1"
                            :name="'住所（丁目、番地）'"
                            validate="required"
                          />
                        </td>
                      </tr>
                      <tr
                        v-if="
                          customer || reqParams.delivaryTarget == 'hospital'
                        "
                      >
                        <th>住所（建物名、号室）</th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.deliveryAddress3"
                            maxlength="256"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>納品先宛名<span class="require" /></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.receiverName"
                            maxlength="100"
                            class="1"
                            :name="'納品先宛名'"
                            validate="required"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>連絡先（電話番号）</th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.deliveryPhoneNumber"
                            maxlength="11"
                            id="mobilePhone"
                            class="1"
                            :class="{ 'border-red': invalidMobilePhoneNumber }"
                            name="連絡先（携帯電話）"
                            validate="numeric"
                            :placeholder="phonePlaceholder"
                          />
                          <div
                            v-show="invalidMobilePhoneNumber"
                            class="text-red"
                          >
                            {{ invalidNumberMessage }}
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div
                  v-if="reqParams.delivaryTarget == 'hospital'"
                  class="orderAttention"
                >
                  <p>
                    ※窓口が複数存在する場合は、機器を受け取る担当部署を必ず入力してください。
                  </p>
                  <p>（例：〇〇階病棟、〇〇科外来窓口　等）</p>
                  <p>※申込みの翌営業日から翌々営業日の出荷が目安となります。</p>
                  <p>
                    注意：配送状況によって、それよりも遅延する場合がございます。
                  </p>
                </div>
                <div
                  style="text-align: left; font-size: 30px; margin-top: 70px"
                >
                  器械
                </div>
                <!-- 器械テーブル -->
                <table
                  class="isEscrow-table"
                  style="margin-bottom: 10px; width: 900px"
                >
                  <thead>
                    <tr>
                      <th class="isEscrow-th" style="width: 4%" scope="col" />
                      <th
                        class="isEscrow-th"
                        style="width: 46%; text-align: center"
                      >
                        CPAP機種・付属品種類
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 29%; text-align: center"
                      >
                        写真
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 8%; text-align: center"
                      >
                        個数
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 6%; text-align: center"
                        scope="col"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in this.reqParams.escrowDeviceList"
                      :key="index"
                      id="tableRow"
                    >
                      <th
                        class="isEscrow-td-instrument"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          font-size: 18px;
                        "
                        scope="row"
                      >
                        {{ index + 1 }}
                      </th>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          @change="changeEscrowItem($event, index)"
                          v-model="reqParams.escrowDeviceList[index].itemName"
                        >
                          <option
                            v-for="(i, index) in escrowDeviceSelectList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="text-align: center"
                      >
                        <img
                          v-if="reqParams.escrowDeviceList[index].imgSrc"
                          :src="reqParams.escrowDeviceList[index].imgSrc"
                        />
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          v-model="reqParams.escrowDeviceList[index].quantity"
                        >
                          <option
                            v-for="(i, index) in quantitySelectList"
                            :key="index"
                            :value="i.quantity"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td"
                        style="vertical-align: middle; text-align: center"
                      >
                        <b-button
                          :disabled="reqParams.escrowDeviceList.length <= 1"
                          class="is-primary w-45"
                          v-on:click="delItems(index)"
                          >削除</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="display: flex">
                  <b-button class="is-primary" @click="addItems">
                    行を追加
                  </b-button>
                </div>
                <div
                  style="text-align: left; font-size: 30px; margin-top: 40px"
                >
                  マスク
                </div>
                <!-- マスクテーブル -->
                <table
                  class="isEscrow-table"
                  style="margin-bottom: 10px; width: 1130px"
                >
                  <thead>
                    <tr>
                      <th class="isEscrow-th" style="width: 3%" scope="col" />
                      <th
                        class="isEscrow-th"
                        style="width: 30%; text-align: center"
                      >
                        種類
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 25%; text-align: center"
                      >
                        写真
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 30%; text-align: center"
                      >
                        品目コード
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 6%; text-align: center"
                      >
                        個数
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 6%; text-align: center"
                        scope="col"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in this.reqParams.escrowMaskList"
                      :key="index"
                      id="tableRow"
                    >
                      <th
                        class="isEscrow-td-instrument"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          font-size: 18px;
                        "
                        scope="row"
                      >
                        {{ index + 1 }}
                      </th>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          v-model="reqParams.escrowMaskList[index].itemName"
                        >
                          <option
                            v-for="(i, index) in escrowMaskSelectList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="text-align: center"
                      >
                        <img
                          v-if="reqParams.escrowMaskList[index].itemName"
                          style="width: 150px; height: 150px"
                          :src="
                            require('@/assets/maskPng/' +
                              maskList[reqParams.escrowMaskList[index].itemName]
                                .fileName +
                              '.png')
                          "
                        />
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          v-if="
                            reqParams.escrowMaskList[index].itemName ==
                            'ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ'
                          "
                          name="item"
                          v-model="reqParams.escrowMaskList[index].itemCode"
                        >
                          <option
                            v-for="(i, index) in picoNesalMaskList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                        <select
                          v-else-if="
                            reqParams.escrowMaskList[index].itemName ==
                            'ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ'
                          "
                          name="item"
                          v-model="reqParams.escrowMaskList[index].itemCode"
                        >
                          <option
                            v-for="(i, index) in wispNesalMaskList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          v-model="reqParams.escrowMaskList[index].quantity"
                        >
                          <option
                            v-for="(i, index) in quantitySelectList"
                            :key="index"
                            :value="i.quantity"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td"
                        style="
                          vertical-align: middle;
                          text-align: center;
                          padding: 12px 8px;
                        "
                      >
                        <b-button
                          :disabled="reqParams.escrowMaskList.length <= 1"
                          class="is-primary w-45"
                          v-on:click="delMasks(index)"
                          >削除</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="display: flex; margin-bottom: 10px">
                  <b-button class="is-primary" @click="addMasks">
                    行を追加
                  </b-button>
                  <input
                    style="margin: 8px 8px 8px 35px; width: 30px"
                    type="checkbox"
                    v-model="maskCatalogActive"
                  />
                  <b-button
                    style="margin-right: 8px; min-width: 250px"
                    type="is-primary"
                    v-on:click="getMaskMaster()"
                    >マスクカタログを表示する</b-button
                  >
                </div>
                <template v-if="maskCatalogActive">
                  <img
                    style="height: 250px"
                    :src="require('@/assets/maskPng/maskList.png')"
                  />
                </template>
                <div
                  style="text-align: left; font-size: 30px; margin-top: 40px"
                >
                  用品
                </div>
                <!-- 用品テーブル -->
                <table
                  class="isEscrow-table"
                  style="margin-bottom: 10px; width: 900px"
                >
                  <thead>
                    <tr>
                      <th class="isEscrow-th" style="width: 4%" scope="col" />
                      <th
                        class="isEscrow-th"
                        style="width: 46%; text-align: center"
                      >
                        用品種類
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 29%; text-align: center"
                      >
                        写真
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 8%; text-align: center"
                      >
                        個数
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 6%; text-align: center"
                        scope="col"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in this.reqParams
                        .escrowOptionItemList"
                      :key="index"
                      id="tableRow"
                    >
                      <th
                        class="isEscrow-td-instrument"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          font-size: 18px;
                        "
                        scope="row"
                      >
                        {{ index + 1 }}
                      </th>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          @change="changeEscrowOption($event, index)"
                          v-model="
                            reqParams.escrowOptionItemList[index].optionItemName
                          "
                        >
                          <option
                            v-for="(i, index) in escrowOptionItemSelectList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="text-align: center"
                      >
                        <img
                          v-if="reqParams.escrowOptionItemList[index].imgSrc"
                          :src="reqParams.escrowOptionItemList[index].imgSrc"
                        />
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          v-model="
                            reqParams.escrowOptionItemList[index].quantity
                          "
                        >
                          <option
                            v-for="(i, index) in quantitySelectList"
                            :key="index"
                            :value="i.quantity"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td"
                        style="vertical-align: middle; text-align: center"
                      >
                        <b-button
                          :disabled="reqParams.escrowOptionItemList.length <= 1"
                          class="is-primary w-45"
                          v-on:click="delOptions(index)"
                          >削除</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="display: flex">
                  <b-button class="is-primary" @click="addOptions">
                    行を追加
                  </b-button>
                </div>
                <div
                  style="text-align: left; font-size: 30px; margin-top: 40px"
                >
                  同梱品
                </div>
                <!-- 同梱品テーブル -->
                <table
                  class="isEscrow-table"
                  style="margin-bottom: 10px; width: 900px"
                >
                  <thead>
                    <tr>
                      <th class="isEscrow-th" style="width: 4%" scope="col" />
                      <th
                        class="isEscrow-th"
                        style="width: 46%; text-align: center"
                      >
                        同梱品（資料）
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 29%; text-align: center"
                      >
                        写真
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 8%; text-align: center"
                      >
                        個数
                      </th>
                      <th
                        class="isEscrow-th"
                        style="width: 6%; text-align: center"
                        scope="col"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in this.reqParams
                        .escrowBundleItemList"
                      :key="index"
                      id="tableRow"
                    >
                      <th
                        class="isEscrow-td-instrument"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          font-size: 18px;
                        "
                        scope="row"
                      >
                        {{ index + 1 }}
                      </th>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          @change="changeEscrowBundle($event, index)"
                          v-model="
                            reqParams.escrowBundleItemList[index].itemName
                          "
                        >
                          <option
                            v-for="(i, index) in escrowBundleItemSelectList"
                            :key="index"
                            :value="i.value"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="text-align: center"
                      >
                        <img
                          v-if="reqParams.escrowBundleItemList[index].imgSrc"
                          :src="reqParams.escrowBundleItemList[index].imgSrc"
                        />
                      </td>
                      <td
                        class="isEscrow-td-instrument"
                        style="vertical-align: middle"
                      >
                        <select
                          name="item"
                          v-model="
                            reqParams.escrowBundleItemList[index].quantity
                          "
                        >
                          <option
                            v-for="(i, index) in quantitySelectList"
                            :key="index"
                            :value="i.quantity"
                          >
                            {{ i.text }}
                          </option>
                        </select>
                      </td>
                      <td
                        class="isEscrow-td"
                        style="vertical-align: middle; text-align: center"
                      >
                        <b-button
                          :disabled="reqParams.escrowBundleItemList.length <= 1"
                          class="is-primary w-45"
                          v-on:click="delBundles(index)"
                          >削除</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="display: flex">
                  <b-button
                    class="is-primary"
                    style="margin-bottom: 300px"
                    @click="addBundles"
                  >
                    行を追加
                  </b-button>
                </div>
              </b-step-item>
              <b-step-item
                v-if="!customer"
                step="2"
                label="見積選択"
                icon="cloud-upload"
              >
                <div id="item-contens">
                  <div class="request-title">
                    <b-button
                      class="is-primary"
                      style="float: left"
                      icon-left="chevron-double-left"
                      @click.prevent="Backward"
                      >前へ</b-button
                    >
                    <b-button
                      class="is-primary"
                      style="float: right"
                      icon-right="chevron-double-right"
                      @click.prevent="Forward"
                      >次へ</b-button
                    >
                    <span>見積を選択してください。</span>
                  </div>
                  <!-- 申込み詳細 -->
                  <CpapEscrowRequestDetail
                    :data="reqParams"
                    :key="renderKey"
                    :editFlg="true"
                  />
                </div>
              </b-step-item>
              <b-step-item step="3" label="注文内容確認" icon="cloud-upload">
                <div id="item-contens">
                  <div class="request-title">
                    <b-button
                      class="is-primary"
                      style="float: left"
                      icon-left="chevron-double-left"
                      @click.prevent="Backward"
                      >前へ</b-button
                    >
                    <span
                      >以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span
                    >
                  </div>
                  <!-- 院内在庫申請　内容確認 -->
                  <CpapEscrowRequestDetail
                    :data="reqParams"
                    v-bind:key="renderKey"
                  />
                  <div class="card-content margin-top">
                    <span style="font-size: 20px">その他</span>
                    <table>
                      <tr>
                        <th style="vertical-align: top">備考</th>
                        <td>
                          <textarea
                            maxlength="256"
                            style="
                              resize: vertical;
                              max-width: 100%;
                              height: 120px;
                            "
                            v-model="reqParams.memo"
                          ></textarea>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <span style="font-size: 14px"
                            >※伝達事項がございましたらご記入ください。</span
                          >
                        </td>
                      </tr>
                    </table>
                  </div>
                  <b-button
                    class="is-primary"
                    style="margin-top: 5px; width: 250px"
                    @click="requestCpap"
                    >申込みを完了する</b-button
                  >
                </div>
              </b-step-item>
              <b-step-item
                step="4"
                label="完了"
                icon="check"
                :type="{ 'is-success': true }"
              >
                <section class="unPrintTarget">
                  <div class="request-title">
                    <span>院内在庫注文を受け付けました。</span>
                  </div>
                  <div class="request-title" v-if="customer">
                    <span style="color: red"
                      >Philipsにて受付を実施いたします。受付完了しましたらメールにてご連絡いたします。</span
                    >
                  </div>
                  <div class="margin-top">
                    <b-button class="backbutton is-primary" @click="back"
                      >戻る</b-button
                    >
                    <b-button
                      class="printbutton is-primary"
                      icon-left="printer"
                      @click="print"
                      >印刷</b-button
                    >
                  </div>
                </section>
                <!-- 申込み詳細 -->
                <CpapEscrowRequestDetail
                  :data="reqParams"
                  :key="renderKey"
                  :editFlg="false"
                  :orderCompleteFlag="true"
                />
              </b-step-item>
            </b-steps>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import {
  role,
  cpapRequestStatus,
  cpapKindMap,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  escrowContent,
  escrowDeviceSelectList,
  escrowMaskSelectList,
  escrowOptionItemSelectList,
  escrowBundleItemSelectList,
  quantitySelectList,
  picoNesalMaskList,
  wispNesalMaskList,
  escrowItemCodeList,
} from "@/components/mock/base/const.js";
import CpapEscrowRequestDetail from "@/components/mock/common/CpapEscrowRequestDetail";
import CpapEscrowRequestDetailEdit from "@/components/mock/common/CpapEscrowRequestDetailEdit";

export default {
  name: "CpapEscrowRequest",
  props: {},
  methods: {
    Backward: function () {
      this.activeStep -= 1;
    },
    Forward: async function (event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item");
      var target;
      for (var item of stepItems) {
        if (item.getAttribute("style") != "display: none;") {
          target = item;
        }
      }
      var activeStep = target ? target.getAttribute("step") : "";
      var elements = document.getElementsByClassName(activeStep);
      var result = this.selfMadeValidation(elements);
      if (activeStep == 1) {
        // TODO:
        // 1.品目が被っていないか
        // 2.個数が抜けていないか
        // 3.1行目を空入力のまま2行目で品目、個数を選択していないか
        // これらの処理をバリデーション実行時にはじくか、又は、正しくない状態にできないようにする
      } else if (activeStep == 2) {
        const notInputItem = this.reqParams.escrowDeviceList.find(
          (v) => v.quotationDetailsNumber == ""
        );
        const notInputMask = this.reqParams.escrowMaskList.find(
          (v) => v.quotationDetailsNumber == ""
        );
        const notInputOption = this.reqParams.escrowOptionItemList.find(
          (v) => v.quotationDetailsNumber == ""
        );
        console.log("notInputItem : " + JSON.stringify(notInputItem));
        console.log("notInputMask : " + JSON.stringify(notInputMask));
        console.log("notInputOption : " + JSON.stringify(notInputOption));
        if (this.reqParams.escrowDeviceList[0].itemName && notInputItem) {
          result.isError = true;
          result.msg = "見積未選択の器械があります。\n";
        } else if (this.reqParams.escrowMaskList[0].itemName && notInputMask) {
          result.isError = true;
          result.msg = "見積未選択のマスクがあります。\n";
        } else if (
          this.reqParams.escrowOptionItemList[0].itemName &&
          notInputOption
        ) {
          result.isError = true;
          result.msg = "見積未選択の用品があります。\n";
        }
      } else if (activeStep === 3) {
      }
      if (result.isError) {
        this.showErrorMessage(result.msg);
      } else {
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey;
        this.activeStep += 1;
      }
    },
    requestCpap: function () {
      // TODO:
      // 「確定する」ボタンの活性条件を設定する等、バリデーションの処理
      const message =
        "院内在庫を注文します。<br/>機種が正しいことを確認して「OK」ボタンを押してください。";
      this.$dialog.confirm({
        title: "申込み確認",
        message: message,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          const excuteApi = this.setCpapEscrowRequestPOST;
          const successCallBack = this.setCpapEscrowRequestPOSTSuccess;
          const errorCallBack = this.setCpapEscrowRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack);
          if (this.compleateFlg) {
            this.jumpToTop();
            this.activeStep += 1;
          }
        },
      });
    },
    setCpapEscrowRequestPOST: function (client) {
      let obj = JSON.parse(JSON.stringify(this.reqParams));

      // 医療機関コード
      obj.medicalInstitutionCode = this.userInfo.medicalInstitutionCode;

      // 納品先 TODO:院内在庫注文の川越発送も2024年に実現したい（PH佐藤さん）
      obj.delivaryTarget = "hospital"; // 現状の支店発送のみの場合は、納品先はhospital（又はディーラー）のみ

      // 外部ユーザーの場合
      if (this.isHospital || this.isDealer) {
        obj.status = this.cpapRequestStatus.request; //　ステータス 指示書申請中：1
      } else {
        // 内部ユーザーの場合
        obj.status = this.cpapRequestStatus.preparingEquipment; // ステータス 機器準備中 : 5
      }

      return client.apis.externalCpap.setCpapEscrowRequestPOST({
        body: obj,
      });
    },
    setCpapEscrowRequestPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.reqParams.applicationDate = result.obj.requestDate;
      this.reqParams.applicationTime = result.obj.requestTime;
      this.reqParams.applicationUserName = result.obj.requestUserName;
      this.reqParams.receiptNumber = result.obj.receiptNumber;
      // 再レンダリングの為、フラグ切替
      this.renderKey = !this.renderKey;
      this.compleateFlg = true;
    },
    setCpapEscrowRequestPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function () {
      if (this.backRoutName) {
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
        });
      } else {
        if (this.preReceiptNumber) {
          this.$router.push({ path: "/guest/home" });
        } else {
          this.$router.go(-1);
        }
      }
    },
    goHome: function () {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/cpap/CpapMenu" });
      } else {
        this.back();
      }
    },
    print: function () {
      window.print();
    },
    addressSearch: function (val) {
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val;
      this.searchTargetAddress = null;
      this.postCodeSearch().then((result) => {
        if (!this.searchTargetAddress) return;
        this.reqParams.deliveryAddress1 =
          this.searchTargetAddress.prefecture +
          " " +
          this.searchTargetAddress.city +
          " " +
          this.searchTargetAddress.town;
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey;
      });
    },
    postCodeSearch: function () {
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function (client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body: {
          postCode: this.searchTargetPostCode,
        },
      });
    },
    getAddressFromPostCodePOSTSuccess: function (result) {
      this.searchTargetAddress = result.obj;
      this.searchTargetPostCode = "";
    },
    getAddressFromPostCodePOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = "";
    },
    changeEscrowItem: function (selectItem, index) {
      // TODO:フィリップスからマスタをもらう手筈だったがもらえていないので、escrowItemCodeListは仮の内容（2023.10丸山）
      const target = this.escrowItemCodeList.find(({itemName}) => itemName == selectItem.target.value);
      if (target) {
        this.reqParams.escrowDeviceList[index].itemCode = target.itemCode
      }
      switch (selectItem.target.value) {
      // TODO:フィリップスよりマスタと画像を入手できたら修正
        case "ドリームステーション Auto":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_AUTO.png");
          break;
        case "ドリームステーション BiPAP Auto":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation-BiPAP.jpg");
          break;
        case "ドリームステーション Go":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "4":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "5":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "6":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "7":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "8":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "9":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "10":
          this.reqParams.escrowDeviceList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        default:
          this.reqParams.escrowDeviceList[index].imgSrc = "";
      }
    },
    changeEscrowOption: function (selectItem, index) {
      // TODO:フィリップスよりマスタと画像を入手できたら修正
      switch (selectItem.target.value) {
        case "花粉フィルタ":
          this.reqParams.escrowOptionItemList[index].itemCode = "RJPG500S16";
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "4":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "5":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "6":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "7":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "8":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "9":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        case "10":
          this.reqParams.escrowOptionItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_GO.png");
          break;
        default:
          this.reqParams.escrowOptionItemList[index].imgSrc = "";
      }
    },
    changeEscrowBundle: function (selectItem, index) {
      // TODO:フィリップスよりマスタと画像を入手できたら修正
      switch (selectItem.target.value) {
        case "QSASガイド":
          this.reqParams.escrowBundleItemList[index].itemCode = "RJPX500S16";
          this.reqParams.escrowBundleItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation_AUTO.png");
          break;
        case "Q&A":
          this.reqParams.escrowBundleItemList[index].itemCode = "RJPX700S16";
          this.reqParams.escrowBundleItemList[
            index
          ].imgSrc = require("@/assets/escrowImg/DreamStation-BiPAP.jpg");
          break;
        default:
          this.reqParams.escrowBundleItemList[index].imgSrc = "";
      }
    },
    addItems: function () {
      this.reqParams.escrowDeviceList.push({ ...escrowContent });
    },
    addMasks: function () {
      this.reqParams.escrowMaskList.push({ ...escrowContent });
    },
    addOptions: function () {
      this.reqParams.escrowOptionItemList.push({ ...escrowContent });
    },
    addBundles: function () {
      this.reqParams.escrowBundleItemList.push({ ...escrowContent });
    },
    delItems: function (index) {
      this.reqParams.escrowDeviceList.splice(index, 1);
    },
    delMasks: function (index) {
      this.reqParams.escrowMaskList.splice(index, 1);
    },
    delOptions: function (index) {
      this.reqParams.escrowOptionItemList.splice(index, 1);
    },
    delBundles: function (index) {
      this.reqParams.escrowBundleItemList.splice(index, 1);
    },
    getBrunchAddressList: function () {
      try {
        this.$store
          .dispatch("getBrunchAddressList", {})
          .then((result) => {
            this.brunchList = result.obj;
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。");
          });
      } catch (err) {
        console.log(error);
        this.showErrorMessage("予期しないエラーが発生しました。");
      }
    },
    getMaskMaster: function () {
      if (!this.maskCatalogActive) {
        this.maskCatalogActive = true;
      } else {
        this.maskCatalogActive = false;
      }
    },
    setOrdererInfo: function () {
      // TODO:2回目移行の注文は前回の入力内容を表示するため、DBへ登録、検索を行う処理が必要
      if (this.isHospital || this.isDealer) {
        this.reqParams.divisionName = this.userInfo.departmentName;
        this.reqParams.ordererName =
          this.userInfo.lastName + " " + this.userInfo.firstName;
        this.reqParams.deliveryPostCode = this.userInfo.postcode;
        this.reqParams.deliveryAddress1 =
          this.userInfo.prefecture + this.userInfo.city;
        this.reqParams.deliveryAddress2 = this.userInfo.address;
        this.reqParams.deliveryAddress3 = this.userInfo.building;
        this.reqParams.receiverName =
          this.userInfo.medicalInstitutionName +
          " " +
          this.userInfo.departmentName;
        this.reqParams.deliveryPhoneNumber = this.userInfo.phoneNumber;
      }
    },
    getOrderHistoryPOST: function (client) {
      let obj = JSON.parse(JSON.stringify(this.reqParams));

      // TODO:(maruyama)userInfo.idでt_cpap_escrow_request:createdIdを検索し、注文履歴を取得

      return client.apis.externalCpap.getOrderHistoryPOST({
        body: obj,
      });
    },
  },
  data() {
    const applicationType = cpapKindMap.application;
    const preReceiptNumber = this.$route.params["receiptNumber"];
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const roleId = userInfo.roleId;
    const userId = userInfo.id;
    const isDealer = roleId == role.role_dealer;
    const isHospital = roleId == role.role_hospital;
    const belongsId = userInfo.belongsId; // 所属先ID
    let reqParams = {
      applicationDate: "", // 申込日
      applicationTime: "", // 申込時間
      instructionDate: this.yyyy_hyp_MM_hyp_dd(new Date()), // 指示日
      isDealer,
      medicalInstitutionName: isHospital
        ? userInfo.medicalInstitutionName + " " + userInfo.departmentName
        : "", // 医療機関名
      medicalInstitutionName:
        userInfo.medicalInstitutionName + " " + userInfo.departmentName, // 医療機関名
      billingDestinationCode: "", // 請求先コード
      customerClass: "", // 備考
      customerOrderNumber: "", // 得意先発注番号
      departmentCode: "", // 診療科コード
      shippingMethod: "", // 発送方法

      shippingDate: null,
      kind: applicationType,

      memo: "", // 備考
      status: cpapRequestStatus.request, // ステータス
      targetHospitalName: "", // 対象医療機関
      deliveryTargetBranchOffice: "", // 機器納品先支店
      receiverName: "", // 納品先宛名
      delivaryTarget: "hospital", // 配送先（支店又は医療機関）
      deliveryPostCode: "", // 納品先郵便番号
      deliveryAddress1: "", // 納品先住所
      deliveryAddress2: "", // 納品先住所（丁目、番地）
      deliveryAddress3: "", // 納品先住所（建物名、号室）
      deliveryPhoneNumber: "", // 納品先電話番号
      escrowDeviceList: [{ ...escrowContent }], // 器械
      escrowMaskList: [{ ...escrowContent }], // マスク
      escrowOptionItemList: [{ ...escrowContent }], // 用品
      escrowBundleItemList: [{ ...escrowContent }], // 同梱品
      senderType: "", // 発送元
      sendBackFlag: false, // 差し戻しフラグ
      userInfo, // ログイン者情報
    };

    const backRoutName = this.$route.params["name"];
    const backRoutParams = this.$route.params;

    return {
      role,
      roleId,
      userId,
      belongsId,
      userInfo,
      activeStep: 0,
      isDealer,
      reqParams,
      compleateFlg: false,
      searchTargetPostCode: "",
      searchTargetAddress: null,
      requestDate: "",
      receiptNumber: "",
      renderKey: true,
      isHospital,
      cpapRequestStatus,
      backRoutName,
      backRoutParams,
      customer: isHospital || isDealer,
      maskCatalogActive: false,
      preReceiptNumber,
      invalidPostcode: false,
      invalidMobilePhoneNumber: false,
      invalidPhoneNumber: false,
      invalidDeliveryPostcode: false,
      invalidDeliveryPhoneNumber: false,
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      escrowDeviceList: [{ ...escrowContent }],
      escrowMaskList: [{ ...escrowContent }],
      escrowOptionItemList: [{ ...escrowContent }],
      escrowBundleItemList: [{ ...escrowContent }],
      brunchList: [],
      escrowDeviceSelectList,
      escrowMaskSelectList,
      escrowOptionItemSelectList,
      escrowBundleItemSelectList,
      quantitySelectList,
      picoNesalMaskList,
      wispNesalMaskList,
      escrowItemCodeList,
      maskList: {
        ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ: { sortNum: 1, fileName: "picoNesalMask" },
        ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ: { sortNum: 2, fileName: "wispNesalMask" },
        ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ: { sortNum: 3, fileName: "dreamWearNasalMask" },
        ﾄﾞﾘｰﾑｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ: { sortNum: 4, fileName: "dreamWispNasalMask" },
        ｺﾝﾌｫｰﾄｼﾞｪﾙﾌﾞﾙｰ: { sortNum: 5, fileName: "comfortGelBlue" },
        "ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ": {
          sortNum: 6,
          fileName: "dreamWearSiliconePillowMask",
        },
        ﾄﾞﾘｰﾑｳｪｱﾌﾙ: { sortNum: 7, fileName: "dreamWearFull" },
        ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ: { sortNum: 8, fileName: "amaraViewFullFaceMask" },
        ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ: { sortNum: 9, fileName: "amaraFullFaceMask" },
        ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ: { sortNum: 10, fileName: "amaraGelFullFaceMask" },
        ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ: {
          sortNum: 11,
          fileName: "wispPediatricNasalMask",
        },
        ﾌｨｯﾄﾗｲﾌ: { sortNum: 12, fileName: "fitLife" },
        その他: { sortNum: 13, fileName: null },
      },
    };
  },
  filters: {
    getNameFilter: function (val, list) {
      var target = list.find((item) => item.value == val);
      if (target) {
        return target.label1;
      }
      return "";
    },
  },
  components: {
    CpapEscrowRequestDetail,
    CpapEscrowRequestDetailEdit,
  },
  async mounted() {
    //支店情報取得
    await this.getBrunchAddressList();
    //注文者情報の自動入力
    await this.setOrdererInfo();

    // TODO:2024年に川越発送を実現したい（PH佐藤さん）
    this.reqParams.delivaryTarget = "hospital";
    this.reqParams.senderType = 1;
  },
  created: function () {
    this.$validator.extend("validationCheck", {
      getMessage: (field) => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      },
    });
  },
  watch: {
    "reqParams.deliveryPostCode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "reqParams.deliveryTargetBranchOffice"() {
      // 選択された支店に応じて営業所マスタから値を取得し画面に反映する
      const targetBranch = this.brunchList.find(
        (v) => v.branchOfficeCode == this.reqParams.deliveryTargetBranchOffice
      );
      this.reqParams.deliveryPostCode = targetBranch.postCode.replace(
        /[^0-9]/g,
        ""
      );
      this.reqParams.deliveryAddress1 = targetBranch.address;
      this.reqParams.receiverName =
        this.userInfo.lastName + " " + this.userInfo.firstName;
      this.reqParams.deliveryPhoneNumber = targetBranch.phoneNumber.replace(
        /[^0-9]/g,
        ""
      );
    },
    "reqParams.delivaryTarget"() {
      // 配送先ラジオボタンが変更された場合に値を削除する
      this.reqParams.deliveryTargetBranchOffice = "";
      this.reqParams.deliveryPostCode = "";
      this.reqParams.deliveryAddress1 = "";
      this.reqParams.deliveryPhoneNumber = "";
      this.reqParams.receiverName = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.orderAttention {
  text-align: left;
  font-size: 20px;
  color: red;
}
.orderAttention p {
  font-weight: bold;
}
.isEscrow-table {
  text-align: center;
  vertical-align: center;
  border-collapse: collapse;
  border: 1px solid #000;
}
.isEscrow-th {
  text-align: center;
  font-size: 20px;
  border: 1px solid #000;
  background-color: #061e57;
  color: #fff;
  padding: 10px;
}
.isEscrow-td {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
  vertical-align: center;
}
.isEscrow-td-instrument {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
  vertical-align: center;
  height: 171px !important;
}
.isEscrow-td-instrument img {
  text-align: center;
  width: 150px;
  height: 150px;
  border: 1px solid #ddd;
  object-fit: fill;
}
.shippingDate {
  width: 150px !important;
}
.valueInput {
  width: 150px;
}
#item-contens table.settings tr th {
  width: 300px;
}
.w-45 {
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapEscrowRequest.vue